import { CHIPS_AGENTE } from '../utils';

interface Props {
  aoEscolher: (texto: string) => void;
  escondido?: boolean;
  desabilitado?: boolean;
}

// Fileira de perguntas prontas acima do campo de digitar (rola na horizontal).
export default function ChipsPerguntas({ aoEscolher, escondido = false, desabilitado = false }: Props) {
  if (escondido) return null;

  return (
    <div className="mx-auto w-full max-w-[720px]">
      <div className="flex gap-2 overflow-x-auto px-0.5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {CHIPS_AGENTE.map((c) => (
          <button
            key={c.rotulo}
            type="button"
            onClick={() => aoEscolher(c.texto)}
            disabled={desabilitado}
            className="aperta flex h-10 shrink-0 cursor-pointer items-center whitespace-nowrap rounded-full border border-background-200 bg-white px-4 text-[14px] font-medium text-foreground-800 transition-colors hover:bg-background-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {c.rotulo}
          </button>
        ))}
      </div>
    </div>
  );
}